module.exports = __webpack_public_path__ + "static/media/location_buenos_aires.33d6fda2.jpg";